import { api, ApiError } from '../../shared/api/client';
import { Button, Card, ErrorState, Loading } from '../../shared/ui/components';
import { useAsync } from '../../shared/ui/useAsync';
import { withRefLinks } from './Dictionary';

interface CommentaryChapter {
  intro: string[];
  outline: { range: string; title: string }[];
  sections: { range: string; paragraphs: string[] }[];
  attribution: string;
}

const versesLabel = (range: string) => (!range ? '' : /[-,]/.test(range) ? `Versículos ${range.replace(/,/g, ', ')}` : `Versículo ${range}`);

/** En la lectura: el comentario de Matthew Henry del capítulo, en español. */
export function Commentary({ book, chapter, onClose }: { book: string; chapter: number; onClose: () => void }) {
  const data = useAsync((signal) => api.get<CommentaryChapter>(`/bible/commentary/chapter?book=${book}&chapter=${chapter}`, signal), [book, chapter]);
  const close = <Button variant="ghost" onClick={onClose}>Cerrar</Button>;
  if (data.status === 'loading') return <Card title="Comentario de Matthew Henry" action={close}><Loading /></Card>;
  if (data.status === 'error') {
    return (
      <Card title="Comentario de Matthew Henry" action={close}>
        {data.error instanceof ApiError && data.error.status === 404 ? <p className="muted">Este capítulo del comentario todavía se está traduciendo. Pronto estará disponible.</p> : <ErrorState error={data.error} />}
      </Card>
    );
  }
  const c = data.data;
  return (
    <Card title="Comentario de Matthew Henry" action={close}>
      <div className="commentary">
        {c.intro.map((p, i) => (
          <p key={`i${i}`} className="commentary__intro">{withRefLinks(p)}</p>
        ))}
        {c.outline.length > 1 ? (
          <ul className="commentary__outline">
            {c.outline.map((o) => (
              <li key={o.range + o.title}>
                {o.range ? <strong>{o.range.replace(/,/g, ', ')}</strong> : null} {o.title}
              </li>
            ))}
          </ul>
        ) : c.outline[0] ? <p><strong>{c.outline[0].title}</strong></p> : null}
        {c.sections.map((s, i) => (
          <section key={i} className="commentary__section">
            {s.range ? <h3 className="commentary__range">{versesLabel(s.range)}</h3> : null}
            {s.paragraphs.map((p, j) => (
              <p key={j}>{withRefLinks(p)}</p>
            ))}
          </section>
        ))}
      </div>
      <p className="small muted atlas__credit">{c.attribution}</p>
    </Card>
  );
}
